import { useRepo } from 'pinia-orm'
import { Community } from '@/models/Community'
import { Composition } from '@/models/Composition'
import { EntityToPrint } from '@/models/EntityToPrint'
import { Globalconfig } from '@/models/Globalconfig'
import { Grocery } from '@/models/Grocery'
import { GroceryList } from '@/models/GroceryList'
import { GroceryMeal } from '@/models/GroceryMeal'
import { Ingredient } from '@/models/Ingredient'
import { Meal } from '@/models/Meal'
import { Recipe } from '@/models/Recipe'
import { RecipeIngredient } from '@/models/RecipeIngredient'
import { RecipeMeal } from '@/models/RecipeMeal'
import { Storage } from '@/models/Storage'
import { Store } from '@/models/Store'
import { StoredItem } from '@/models/StoredItem'
import { User } from '@/models/User'
import { UserCommunity } from '@/models/UserCommunity'

export function resetAllStores() {
  const ormModels = [
    Community,
    Composition,
    EntityToPrint,
    Globalconfig,
    Grocery,
    GroceryList,
    GroceryMeal,
    Ingredient,
    Meal,
    Recipe,
    RecipeIngredient,
    RecipeMeal,
    Storage,
    Store,
    StoredItem,
    User,
    UserCommunity
  ]

  for (const model of ormModels) {
    useRepo(model).flush()
  }
}
